// import Users from './Users';

export default {
  priority: 11,
  path: 'user',
  permissions: ['StackSignalPackAssignment'],
  // component: Users,
  component: load(() => import(/* webpackChunkName: "Stack-Pack-Users" */ './Users')),
  name: app.translate('routes.home.attendance.shift.Users'),
  icon: 'account-check',
  drawer: false,
};


